import React, { useState } from "react";
import classes from "../styles/style.module.css";
import { baseURL } from "../../../assets/constants/baseUrl";

import { FaPlay } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
import { BiSolidEdit } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";

import HubbleButton from "./HubbleButton";
import VideoPlayer from "../../../assets/components/VideoPlayer";

import {
  convertToShamsiTime,
  convertToShamsi,
} from "../../../assets/utils/ConvertToShamsi";
import { useNavigate } from "react-router";
import RemoveUploadDialog from "./RemoveUploadDialog";

const MyUploadsElement = ({ data, handleDelete }) => {
  const [openVideo, setopenVideo] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);

  const navigate = useNavigate();

  return (
    <div className={classes.myUploadContainer}>
      <div className={classes.videoBg}>
        <img src="/images/hubble/hubbleVideoBg.jpg" alt="video-bg" />
        <div
          className={classes.playIconContainer}
          onClick={() => setopenVideo(true)}
        >
          <div className={classes.play}>
            <FaPlay className="ml-1" onClick={() => setopenVideo(true)} />
          </div>
        </div>
      </div>
      <div className="row mt-5 mb-4">
        <div className="col-6">تاریخ:</div>
        <div className="col-6 justify-content-end d-flex">
          <div className="d-flex flex-column justify-content-center align-items-end font-weight-bold">
            <span className="text-left">
              {convertToShamsi(data.createdAt) +
                " " +
                convertToShamsiTime(data.createdAt)}
            </span>
          </div>
        </div>
      </div>
      <div className="row my-4">
        <div className="col-6">رشته:</div>
        <div className="col-6 justify-content-end d-flex">
          <div className="d-flex flex-column justify-content-center align-items-end">
            <span className="text-left">{data.major}</span>
          </div>
        </div>
      </div>
      {!data.hasOwnProperty("allowedToProceedToNextLevel") && (
        <div className="row mb-4">
          <div className="col-6">داوری:</div>
          <div className="col-6 justify-content-end d-flex">
            <div className="d-flex flex-column justify-content-center align-items-end">
              <span className="flex">
                <FaStar color="#7F84B1" className="mx-1" />
                <FaStar color="#7F84B1" className="mx-1" />
                <FaStar color="#7F84B1" className="mx-1" />
                <FaStar color="#7F84B1" className="mx-1" />
                <FaStar color="#7F84B1" className="mx-1" />
              </span>
              <span className="text-left">(به زودی)</span>
            </div>
          </div>
        </div>
      )}

      {data.hasOwnProperty("allowedToProceedToNextLevel") ? (
        data.allowedToProceedToNextLevel ? (
          <div className={classes.allowedBox}>
            <strong>شرکت‌کننده گرامی تبریک!</strong>
            <br />
            اثر شما در جشنواره فرهنگی و استعدادیابی هابل با موفقیت به مرحله
            مقدماتی راه یافت.
            <br />
            ضمن تبریک به اطلاع میرسانیم، ادامه روند و مراحل بعدی متعاقبا به
            اطلاع شما خواهد رسید.
          </div>
        ) : (
          <div className={classes.notAllowedBox}>
            <strong>شرکت‌کننده محترم</strong>
            <br />
            با سپاس از حضور ارزشمندتان در جشنواره هابل، متأسفانه اثر ارسالی‌ شما
            به مرحله مقدماتی راه نیافت.
            <br />
            امیدواریم با تلاش بیشتر شما هم از ستاره‌های دوره های بعدی این
            جشنواره باشید.
          </div>
        )
      ) : null}

      {!data.hasOwnProperty("allowedToProceedToNextLevel") && (
        <div className="mt-4 row ">
          <div className="col-6">
            <HubbleButton
              style={{
                border: "2px solid var(--hubbleAccentColor)",
              }}
              onClick={() => navigate(`/hubble/upload/edit/${data._id}`)}
            >
              <BiSolidEdit fontSize={20} className="ml-1" />
              ویرایش
            </HubbleButton>
          </div>
          <div className="col-6">
            <HubbleButton
              onClick={() => setOpenRemoveDialog(true)}
              style={{
                backgroundColor: "transparent",
                color: "var(--hubbleAccentColor)",
                border: "2px solid var(--hubbleAccentColor)",
              }}
            >
              <RiDeleteBinLine fontSize={20} className="ml-1" />
              حذف
            </HubbleButton>
          </div>
        </div>
      )}
      <VideoPlayer
        open={openVideo}
        closeHandler={() => setopenVideo(false)}
        videoUrl={`${baseURL}file/get/${data.file}`}
      />
      <RemoveUploadDialog
        open={openRemoveDialog}
        onClose={() => setOpenRemoveDialog(false)}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default MyUploadsElement;
